import React, { useState } from "react";
import axios from "../utils/axiosConfig.js";
import { toast } from "react-toastify";
import AvailableTimesDialog from "./schedule/AvailableTimesDialog.js";
import "./StudentNew.css";
import { API_URL } from "../config/api.js";

const StudentForm = () => {
  const [editingAvailableTimes, setEditingAvailableTimes] = useState(false);
  const [student, setStudent] = useState({
    firstName: "",
    lastName: "",
    skillLevel: "",
    sex: "",
    adress: "",
    email: "",
    phone: "",
    member: true,
    team: false,
    trainigGroup: "",
    birthDate: "",
    availableTimes: [],
    comment: "",
    adult: true,
    coach: "",
    frequence: "",
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/api/students`, student); // Speichere den Schüler in der Datenbank
      toast.success("Schüler erfolgreich hinzugefügt!");

      // Resette den State auf die initialen Werte
      setStudent({
        firstName: "",
        lastName: "",
        skillLevel: "",
        sex: "",
        adress: "",
        email: "",
        phone: "",
        member: true,
        team: false,
        trainigGroup: "",
        birthDate: "",
        availableTimes: [],
        comment: "",
        adult: true,
        coach: "",
        frequence: "",
      });
    } catch (error) {
      console.error("Fehler:", error);
      const errorMessage = error.response?.data?.error || "Fehler beim Hinzufügen des Schülers";
      toast.error(errorMessage);
    }
  };

  const handleSaveAvailableTimes = (selectedTimes) => {
    console.log("Ausgewählte Zeiten:", selectedTimes);
    setStudent((prev) => ({
      ...prev,
      availableTimes: selectedTimes,
    }));
    setEditingAvailableTimes(false);
  };

  return (
    console.log("Student vor Dialog:", student),
    (
      <div className="student-new-container">
        <div className="student-new-header">
          <h1>➕ Neuen Schüler anlegen</h1>
        </div>

        {editingAvailableTimes && (
          <AvailableTimesDialog
            entity={student}
            closeDialog={() => setEditingAvailableTimes(false)}
            handleSaveAvailableTimes={handleSaveAvailableTimes}
          />
        )}

        <form onSubmit={handleSubmit}>
          <div className="student-new-card">

            <div className="form-field">
              <label htmlFor="firstName">Nachname</label>
              <input
                type="string"
                placeholder="Nachname"
                value={student.lastName}
                onChange={(e) =>
                  setStudent({ ...student, lastName: e.target.value })
                }
              />
            </div>
             <div className="form-field">
              <label htmlFor="firstName">Vorname</label>
              <input
                type="string"
                placeholder="Vorname"
                value={student.firstName}
                onChange={(e) =>
                  setStudent({ ...student, firstName: e.target.value })
                }
              />
            </div>
            <div className="form-field">
              <label htmlFor="birthDate">Geburtsdatum</label>
              <input
                type="string"
                placeholder="YYYY-MM-DD"
                value={student.birthDate}
                onChange={(e) =>
                  setStudent({ ...student, birthDate: e.target.value })
                }
              />
            </div>
            <div className="form-field">
              <label htmlFor="email">E-Mailadresse</label>
              <input
                type="string"
                placeholder="E-Mailadresse"
                onChange={(e) =>
                  setStudent({ ...student, email: e.target.value })
                }
              />
            </div>
            <div className="form-field">
              <label htmlFor="phone">Telefonnumer</label>
              <input
                type="string"
                placeholder="Telefonnummer"
                onChange={(e) =>
                  setStudent({ ...student, phone: e.target.value })
                }
              />
            </div>
            <div className="form-field">
              <label htmlFor="adress">Adresse</label>
              <input
                type="string"
                placeholder="Adresse"
                onChange={(e) =>
                  setStudent({ ...student, adress: e.target.value })
                }
              />
            </div>
{/* Ende Stammdaten ------------------------------------------------------*/}
            <div className="form-field">
              <label htmlFor="availableTimes">Trainingszeiten</label>
              <button
                type="button"
                onClick={() => setEditingAvailableTimes(true)}
              >
                Trainingszeiten bearbeiten
              </button>
            </div>
            
<div className="form-field">
  <label htmlFor="adult">Erwachsenen-Training</label>
  <div className="toggle-switch">
    <input
      type="checkbox"
      id="adult"
      name="adult"
      checked={student.adult}
      onChange={(e) =>
        setStudent((prev) => ({
          ...prev,
          adult: e.target.checked,
          // Wenn wieder auf Erwachsene gesetzt wird, trainigGroup leeren
          ...(e.target.checked && { trainigGroup: "" }),
        }))
      }
    />
    <span className="toggle-label">
      {student.adult ? "Ja" : "Nein"}
    </span>
  </div>
</div>
            
            <div className="form-field">
              <label htmlFor="member">Mitglied</label>
              {/* Toggle-Switch: 
                - Checkbox verwaltet Boolean direkt 
                - Bei checked: "Ja", sonst "Nein" */}
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  id="member"
                  name="member"
                  checked={student.member}
                  onChange={(e) =>
                    setStudent((prev) => ({
                      ...prev,
                      member: e.target.checked,
                    }))
                  }
                />
                <span className="toggle-label">
                  {student.member ? "Ja" : "Nein"}
                </span>
              </div>
            </div>

{/* Nur wenn „Erwachsenen-Training“ deaktiviert ist, Gruppe wählen */}
{!student.adult && (
  <div className="form-field">
    <label htmlFor="trainigGroup">Kinder-Gruppe</label>
    <select
      id="trainigGroup"
      name="trainigGroup"
      value={student.trainigGroup}
      onChange={(e) =>
        setStudent((prev) => ({
          ...prev,
          trainigGroup: e.target.value,
        }))
      }
    >
      <option value="">Bitte wählen</option>
      <option value="Kinderland">Kinderland</option>
      <option value="Rot">Kids Rot</option>
      <option value="Grün">Grün</option>
      <option value="Orange">Orange</option>
      <option value="Gelb Team">Gelb Team</option>
      <option value="Gelb Hobby">Gelb Hobby</option>
    </select>
  </div>
)}
            {student.adult && (
            <>
            <div className="form-field">
              <label htmlFor="skillLevel">Spielstärke</label>
              <select
                id="skillLevel"
                name="skillLevel"
                type="text"
                value={student.skillLevel}
                onChange={(e) =>
                  setStudent({ ...student, skillLevel: e.target.value })
                }
              >
                <option value="">Bitte wählen</option>
                <option value="Anfänger">Anfänger</option>
                <option value="Anfänger mit Grundkenntnissen">
                  Anfänger mit Grundkenntnissen
                </option>
                <option value="Fortgeschritten">Fortgeschritten</option>
                <option value="Erfahrene Spieler:innen / Mannschaftsspieler:innen">
                  Erfahrene Spieler:innen / Mannschaftsspieler:innen
                </option>
                <option value="Leistungsspieler:innen / Turnierspieler:innen">
                  Leistungsspieler:innen / Turnierspieler:innen
                </option>
              </select>
            </div>
            <div className="form-field">
              <label htmlFor="sex">Geschlecht</label>
              <select
                id="sex"
                name="sex"
                value={student.sex}
                onChange={(e) =>
                  setStudent({ ...student, sex: e.target.value })
                }
              >
                <option value="">Bitte wählen</option>
                <option value="männlich">männlich</option>
                <option value="weiblich">weiblich</option>
              </select>
            </div>
            </>
            )}
            {!student.adult && (
         <div className="form-field">
            <label htmlFor="team">Team</label>
            <div className="toggle-switch">
            <input
              type="checkbox"
              id="team"
              name="team"
              checked={student.team}
              onChange={(e) =>
                setStudent((prev) => ({
                  ...prev,
                  team: e.target.checked,
                }))
              } 
            />
          </div>
          </div>
          )}

            <div className="form-field">
              <label htmlFor="frequence">Trainigshäufigkeit</label>
              <select
                id="frequence"
                name="frequence"
                type="text"
                value={student.frequence}
                onChange={(e) => {
                  //console.log("Ausgewählter Wert:", e.target.value); // Überwache den Wert
                  setStudent((prev) => ({
                    ...prev,
                    frequence: e.target.value, // Aktualisiert den Zustand
                  }));
                }}
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
            </div>
            <div className="form-field">
              <label htmlFor="comment">Notiz</label>
              <input
                type="string"
                placeholder="Notiz"
                onChange={(e) =>
                  setStudent({ ...student, comment: e.target.value })
                }
              />
            </div>
            <div className="form-actions">
              <button className="btn-primary" type="submit">
                ✅ Schüler hinzufügen
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  );
};

export default StudentForm;
